import type Quill from 'quill/core';
import * as styles from './getContentRectForCurrentSelection.module.scss';
import type { RelativeDOMRect } from './toRelativeDOMRect';
import { getRangeSaver } from '../../editor/RangeSaver';
import getRangeBoundaries from '../../editor/utils/getRangeBoundaries';

const COMMENT_THREAD_COMPACT_AVATAR_PADDING = parseInt(
  styles.commentThreadCompactAvatarPadding,
  10,
);

const getContentRectForCurrentSelection = (quill: Quill) => {
  const boundaries = getRangeBoundaries(quill, getRangeSaver(quill).getLast());

  if (!boundaries?.length) return null;

  const top = Math.min(...boundaries.map((rect) => rect.top));
  const bottom =
    Math.max(...boundaries.map((rect) => rect.top + rect.height)) +
    COMMENT_THREAD_COMPACT_AVATAR_PADDING;

  // The DOMRect we return here is always relative to quill's container,
  // so we can use the tagged type RelativeDOMRect for better type safety.
  return DOMRect.fromRect({
    x: Math.min(...boundaries.map((rect) => rect.left)),
    y: top,
    height: bottom - top,
  }) as RelativeDOMRect;
};

export default getContentRectForCurrentSelection;
